module.exports = __webpack_public_path__ + "img/SpeakerActive.8379a2ff.svg";